import { classes, filterChangeEventName, selectors } from './lib';

const hideElement = (el) => (el.hidden = true);
const showElement = (el) => (el.hidden = false);

export const onFilterSelectChange = (e) => {
	const filterNavigation = e.target.closest(selectors.filterNavigation);

	// Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
	if (e.isTrusted) {
		window.location.hash = e.target.value;
	}

	// Dispatch the filter change event
	filterNavigation.dispatchEvent(new CustomEvent(filterChangeEventName, { detail: { filterValue: e.target.value }, bubbles: true }));
};

export const onFilterButtonClick = (e) => {
	const target = e.currentTarget;
	const filterNavigation = target.closest(selectors.filterNavigation);
	const selectedFilter = filterNavigation.querySelector(selectors.activeFilterElement);

	// If the "always on" property is enabled, it should prevent the currently active filter from being disabled when the user clicks on it.
	if (filterNavigation.classList.contains(classes.filterAlwaysOn) && target === selectedFilter) {
		return;
	}

	if (selectedFilter && selectedFilter === target) {
		// Clicked the item that was already selected
		target.classList.remove(classes.active);
	} else {
		// Clicked another item than the selected one
		selectedFilter?.classList.remove(classes.active);
		target.classList.add(classes.active);
	}

	const filterValue = filterNavigation.querySelector(selectors.activeFilterElement)?.getAttribute('data-cat') || '';

	// Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
	if (e.isTrusted) {
		window.location.hash = filterValue;
	}

	// Dispatch the filter change event
	filterNavigation.dispatchEvent(new CustomEvent(filterChangeEventName, { detail: { filterValue }, bubbles: true }));
};

export const handleTileVisibility = (tilesContainer, filterValue) => {
	if (!tilesContainer) {
		return;
	}

	tilesContainer.querySelectorAll(selectors.tiles).forEach((tile) => {
		// Show every tile
		showElement(tile);

		if (filterValue) {
			// Hide tile if it its categories don't contain the target category
			const tileCategories = tile.getAttribute('data-cat').split(' ');
			!tileCategories.includes(filterValue) && hideElement(tile);
		}
	});
};
